module.exports = __webpack_public_path__ + "static/media/place_students_schedule_complete.e613072d.mov";